<template>
<div class="chapter">
<div class="inner_page">
<p class="blackquote"><a id="file_021"></a><a id="page_10"><em>Sculptural needle felting involves a few easy techniques. Practice each of these processes and you will soon have the skills to create any of the projects in this book.</em></a></p><a id="page_10">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_021.vue?1c253a7b